import getEndShortEventsByCloudSetting from '../selectors/getEndShortEventsByCloudSetting';
import { isFeatureEnabled } from 'owa-feature-flags';

const DEFAULT_END_SHORT_EVENTS_BY_FALLBACK = 5;

/**
 * Gets the default value for the duration to reduce the short events (less than one hour)
 */
export default function getDefaultEndShortEventsBy(): number {
    if (!isFeatureEnabled('cal-mf-shouldEventsEndEarlySetting')) {
        return 0;
    }

    const endShortEventsBy = getEndShortEventsByCloudSetting();

    return endShortEventsBy != null ? endShortEventsBy : DEFAULT_END_SHORT_EVENTS_BY_FALLBACK;
}
